/*=========================================================================================
  File Name: moduleDeviceState.js
  Description: Device Module State
==========================================================================================*/

export default {
	devices: [],
	totalDevices: 0,
	devicesStatus: [],
	devicesSearchQuery: "",
	devicesFilter: null,
	kpiDetails: [],
	isFetchedDevices: false,
	categories: [],
	inventories: [],
	accessories: [],
	limitPerPage: 10,
	material: [],
	kpi: [],
	totalAccessories: 0,
	totalMaterial: 0,
	totalKpi: 1,
	totalKpiDetails: 0,
	logsCurrentTodo: [],
	logsDoneTodo: [],
	totalLogsCurrentTodo: 0,
	totalLogsDoneTodo: 0,
	requestsByDevice: [],
	totalRequestsByDevice: 0
};
